import React from "react";
import HeroImage from "../sections/ServiceCostCal/HeroImage";
// import EstimatedHighToLowCostGraph from "../sections/ServiceCostCal/EstimatedHighToLowCostGraph";
import ServicesOnMap from "../sections/ServiceCostCal/ServicesOnMap";
import Tips from "../sections/ServiceCostCal/Tips";
import FAQs from "../sections/ServiceCostCal/FAQs";
import DoubleLineSlider from "../sections/ServiceCostCal/DoubleLineSlider";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import {
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const ServiceCostCal = () => {
  return (
    <>
      <HeroImage />
      {/* <EstimatedHighToLowCostGraph /> */}
      <DoubleLineSlider />
      <ServicesOnMap />
      <Tips />
      <FAQs />
      <FullLengthSlider
        className={PUBLIC_SECTION_GAP_CLASS}
        itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
        labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
      />
    </>
  );
};

export default ServiceCostCal;
